import React from 'react'
import nextCookie from 'next-cookies'

import GlacierError from '@dashboard/components/GlacierError'
import Dashboard from '@dashboard/components/Dashboard'
import Public from '@dashboard/components/DashboardPublic'
import { NextPageContext } from 'next'
import { CRYSTAL_AUTH_TOKEN } from '@dashboard/lib/constants'

export interface OwnProps {
  authToken: string
  statusCode: number | undefined
}

export default class ErrorPage extends React.Component<OwnProps> {
  static async getInitialProps(ctx: NextPageContext) {
    const { res, err } = ctx
    const { [CRYSTAL_AUTH_TOKEN]: authToken } = nextCookie(ctx)

    const statusCode = res?.statusCode || err?.statusCode || null

    return {
      authToken,
      statusCode,
    }
  }

  render() {
    const { authToken } = this.props

    if (authToken) {
      return (
        <Dashboard
          pageName="Error"
          childRenderer={() => this.renderAuthedContent()}
        ></Dashboard>
      )
    } else {
      return (
        <Public>
          <GlacierError
            pageTitle={this.getPageTitle()}
            title="Whoops, didn't see that one coming."
            cta={this.getCtaOptions()}
            subCta={this.getSubCtaOptions()}
          />
        </Public>
      )
    }
  }

  renderAuthedContent = () => {
    return (
      <GlacierError
        pageTitle={this.getPageTitle()}
        title="Whoops, didn't see that one coming."
        subtitle={this.getSubtitle()}
        cta={this.getCtaOptions()}
      />
    )
  }

  // Functions
  getSubtitle() {
    const { statusCode } = this.props

    if (statusCode === 404)
      return 'You may have mistyped the address or the page may have moved.'
    else return 'Something went wrong, sorry about that.'
  }

  getCtaOptions() {
    const { authToken } = this.props
    if (authToken) return { text: 'Return to home page', href: '/app' }
    else
      return {
        text: 'Take our personality test',
        href: 'https://www.crystalknows.com/personality-test',
      }
  }

  getSubCtaOptions() {
    return {
      text: 'Learn about Personality',
      href: 'https://www.crystalknows.com/personalities',
    }
  }

  getPageTitle() {
    const { statusCode } = this.props

    if (statusCode === 404) return 'Crystal Comparison - Page Not Found'
    else return 'Crystal - Something went wrong'
  }
}
